import chain from '@ersinfotech/chain';
import _ from 'lodash';
import { loop, Effects } from 'redux-loop';
import { FETCH_SOURCE_AREA, FETCH_SOURCE_AREA_SUCCESS } from './actions';
import { fetchSourceArea } from './tasks';

export default (state = {}, action) => {
  if (action.type === FETCH_SOURCE_AREA) {
    return loop(
      state
    ,
      Effects.promise(fetchSourceArea, action.data)
    );
  };

  if (action.type === FETCH_SOURCE_AREA_SUCCESS) {
    return loop({
      ...state,
      ...action.data,
    },
      Effects.none()
    );
  };

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceArea/reducer.js
 **/